import styled from 'styled-components';

// Layout flex column (substitui grid com fracoes 0.2/0.2/0.3/8 que
// gerava linhas de altura imprevisivel). Cada linha tem altura natural;
// a lista (ultima) pega o resto via flex:1.
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  /* Padrao responsivo do projeto: offset do rail fixo (64px) com
     width baseada em 100vw. A formula antiga (width calc(100%-140px)
     + margin-left 105px) somava restricoes do parent + offset proprio,
     resultando em conteudo jogado pra fora da tela. */
  width: calc(100vw - 64px);
  min-height: calc(100vh - 40px);
  margin: 15px 0 25px 64px;
  padding: 0 var(--cco-pad);
  box-sizing: border-box;

  .style-container-aplicacao {
    background: ${(props) => props.theme.colors.card};
    border-radius: 8px;
  }

  @media (max-width: 720px) {
    width: 100vw;
    margin: 15px 0 25px 0;
  }
`;

// Header com 4 cards lado-a-lado. Em telas estreitas quebram em 2 linhas.
// IMPORTANTE: grid items recebem 'min-width: 0' pra respeitar a coluna
// (default min-width:auto deixa conteudo intrinseco "empurrar" colunas
// adjacentes, causando sobreposicao visual). + altura fixa de 80px (em
// vez do max-height 72px que clipava conteudo) garante que TODOS os
// cards tem o mesmo bounding box.
export const Line = styled.div`
  display: grid;
  column-gap: 16px;
  row-gap: 12px;

  ${(props) => {
    if (props.header) {
      return `
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.2fr);
        align-items: stretch;

        > * {
          min-width: 0;
          min-height: 0;
          height: 80px;
          overflow: hidden;
        }

        @media (max-width: 1280px) {
          grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
          > * {
            height: 72px;
          }
        }

        @media (max-width: 720px) {
          grid-template-columns: 1fr;
        }
      `;
    }
    if (props.second) {
      return `
        grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
      `;
    }
    if (props.third) {
      return `
        grid-template-columns: 1fr;
      `;
    }
    return `
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    `;
  }}
`;

// Wrapper especifico pra linha 2 (tabs + busca/chips). Layout duas
// colunas: tabs ocupam o espaco, busca+chips fica na direita.
export const TabsAndSearch = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(280px, 1fr);
  gap: 14px;
  align-items: start;

  @media (max-width: 1280px) {
    grid-template-columns: 1fr;
  }
`;

export const TabsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 10px;
`;
